










































import { getFormInputMixin } from '@/mixins/formInputMixin';
import { FormList } from '@/types/forms/fields/formList';
import { FormElementConfig } from '@/types/forms/formElement';
import { PropType } from 'vue';
import FormField from '../formField/FormField.vue';
import { TextField } from '@/types/forms/fields/textField';
import { TextInputWithUnitContent } from '@/api/interfaces/content/form/base/textInputWithUnitContent';
import FormInputText from '@/components/atoms/formInputText/FormInputText.vue';
import { FormInputPosition } from '@/enums/formInputPosition';
import Icon from '@/components/atoms/icon/Icon.vue';

export default getFormInputMixin<
    FormList<TextField, FormElementConfig>,
    TextInputWithUnitContent
>().extend({
    name: 'FormInputTextFormList',
    components: {
        FormField,
        FormInputText,
        Icon,
    },
    props: {
        showInfoIcon: {
            type: Boolean,
            default: false,
        },
        alignField: {
            type: String as PropType<FormInputPosition>,
            default: FormInputPosition.nextToLabel,
        },
    },
    computed: {},
    methods: {
        showIcon(index: number): boolean {
            return index === 0 ? this.model.canAddItem() : true;
        },
        handleIconClick(mode: 'add' | 'remove', index: number): void {
            if (mode === 'remove') {
                this.model.removeAt(index);
                return;
            }

            if (this.model.canAddItem()) {
                this.model.createItem();
            }
        },
    },
});
